import Busqueda from '../components/Busqueda/busqueda';
export function App() {
  return (
    <>
      <Busqueda activo={true} />
      <div />
    </>
  );
}

export default App;
